import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text} from '@chakra-ui/react'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {EditorialVideo} from '../../video'

export const StoriesSwiperSlide = ({title, bodyCopy, isVideo, video, image, styles}) => {
    const damImage = useDamImage(image)

    return (
        <Flex data-testid="stories-swiper-slide" flexDirection={'column'} {...styles.slide}>
            {isVideo ? (
                <Box width={'100%'} height={'100%'}>
                    <EditorialVideo data={video} style={{objectFit: 'cover'}} />
                </Box>
            ) : (
                <AspectRatio ratio={damImage.ratio} width={'100%'}>
                    <Img
                        src={damImage.url}
                        alt={image?.alt || ''}
                        {...styles.slidemedia}
                        className={'slideimage'}
                    />
                </AspectRatio>
            )}
            <Flex {...styles.slidetextblock} direction={'column'}>
                {title && (
                    <Box {...styles.slidetitle}>
                        <Text textStyle={'head-xlarge'} fontWeight={'medium'}>
                            {title}
                        </Text>
                    </Box>
                )}
                {bodyCopy && (
                    <Box {...styles.slidebodycopy}>
                        <Text
                            textStyle={'body-large'}
                            fontWeight={'normal'}
                            dangerouslySetInnerHTML={{__html: bodyCopy}}
                        />
                    </Box>
                )}
            </Flex>
            <Box {...styles.slidemask}></Box>
        </Flex>
    )
}

StoriesSwiperSlide.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    isVideo: PropTypes.bool,
    video: PropTypes.shape(),
    image: PropTypes.shape(),
    styles: PropTypes.shape(),
}
